import './Plans.css'
import {plansData} from '../../data/plansData';
import tick from '../../assets/whiteTick.png'

const Plans = () => {
    return(
        <>
       
        <div className="plans-container" id='Plans'>
            <div className="plans-header">
                <span className='stroke-text'>Ready to start</span>
                <span>Your Journey </span>
                <span className='stroke-text'>With Us</span>
            </div>


            <div className="blur pblur1"></div>
            <div className="blur pblur2"></div>


            <div className="plans">
           {plansData.map((plan,i)=>(
            <div className="plan" key={i}>
                {plan.icon}
                <span>{plan.name}</span>
                <span>$ {plan.price}</span>

                <div className="features">
                    {plan.features.map((feature,i)=>(
                        <div className="feature">
                         <img src={tick} alt="" />
                         <span key={i}>{feature}</span>
                        </div>
                    ))}
                </div>
                <div className=""><span>See more Benefits</span></div>
                <button className="btn">Join Now</button>
            </div>
           ))}
            </div>
        </div>
        </>
    )
}
export default Plans